
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Alanditomumbaicabs() {



    const cardData =
    {
        keyword: 'Alandi to Mumbai Cabs Service',
        heading: 'Skyline Cabs: Alandi to Mumbai Cabs Service',
        headingDescription: 'Skyline Cabs provides dependable Alandi to Mumbai Cabs Service with a focus on comfort, safety, and punctuality. Whether you’re traveling for a pilgrimage, a family outing, or an airport drop, our clean and well-maintained vehicles are driven by courteous professionals who ensure a smooth ride. Enjoy competitive fares, timely pickups, and 24/7 customer support. Book your Alandi to Mumbai cab with Skyline Cabs today and experience travel made easy.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Cab Service in Alandi Pune",
      "description": "Skyline Cabs offers reliable and prompt cab services in Alandi, Pune. Whether you're traveling locally or planning an intercity trip to Mumbai, we provide a range of vehicles including sedans, Ertiga, and Innova Crysta with professional drivers ensuring a safe and smooth journey."
    },
    {
      "name": "Cab Service in Alandi Pune Contact Number",
      "description": "Get in touch with Skyline Cabs for immediate bookings or inquiries about cab services in Alandi, Pune. Our 24/7 customer support ensures fast assistance, easy reservations, and real-time updates for your trips to Mumbai or nearby cities."
    },
    {
      "name": "Alandi to Mumbai Cabs Service",
      "description": "Skyline Cabs provides affordable and efficient cab service from Alandi to Mumbai. Whether you’re heading to the airport or any area in the city, our fleet includes well-maintained vehicles for both one-way and round-trip rides."
    },
    {
      "name": "Alandi to Mumbai Airport Cabs",
      "description": "Book a cab with Skyline Cabs from Alandi to Mumbai Airport for timely and stress-free airport transfers. Enjoy air-conditioned vehicles, courteous drivers, and flexible booking options suited for your travel needs."
    },
    {
      "name": "Cab Service in Wadmukhwadi",
      "description": "Looking for a cab in Wadmukhwadi? Skyline Cabs offers local and outstation taxi services from Wadmukhwadi to Mumbai, with clean vehicles and professional drivers ensuring reliable and comfortable travel."
    },
    {
      "name": "Cab Service in Charholi Budruk",
      "description": "Skyline Cabs provides dependable cab services in Charholi Budruk, Pune. Whether you need a cab to Mumbai or a local ride, our fleet of sedans and SUVs is ready to serve you 24/7."
    },
    {
      "name": "24 Hours Cab Service in Charholi",
      "description": "Skyline Cabs offers round-the-clock cab services in Charholi. Whether it's an early airport drop or a late-night emergency ride to Mumbai, we’re available any time with safe and comfortable vehicles."
    },
    {
      "name": "Charholi to Mumbai Cab Service",
      "description": "Get a cab from Charholi to Mumbai easily with Skyline Cabs. We offer a variety of options including one-way, round-trip, and airport transfers with experienced drivers and transparent pricing."
    },
    {
      "name": "Moshi to Mumbai Cab Service",
      "description": "Travel from Moshi to Mumbai with Skyline Cabs. Our intercity cabs are available 24/7 and offer options such as sedans, Ertiga, and Innova Crysta to match your group size and comfort requirements."
    },
    {
      "name": "Moshi to Mumbai Cab Fare",
      "description": "Skyline Cabs offers budget-friendly fares for travel from Moshi to Mumbai. Enjoy fixed pricing with no hidden charges, professional drivers, and clean, GPS-enabled vehicles for a smooth ride."
    },
    {
      "name": "Moshi to Mumbai Airport Cab Fare",
      "description": "Need a cab from Moshi to Mumbai Airport? Skyline Cabs offers timely pickups, courteous service, and competitive pricing. Our drivers ensure you reach your flight on time, every time."
    },
    {
      "name": "Moshi to Mumbai Round Trip Cab Fare",
      "description": "Planning a return trip from Moshi to Mumbai and back? Skyline Cabs offers round-trip taxi services at affordable rates, perfect for business visits or same-day returns with full flexibility."
    },
    {
      "name": "Cab Service in Moshi",
      "description": "Skyline Cabs is your trusted local taxi provider in Moshi. We offer city rides, outstation cabs, and airport transfers with a wide fleet of vehicles, including economical and luxury options."
    },
    {
      "name": "Cheapest Cab Service in Moshi",
      "description": "Looking for budget cab options from Moshi? Skyline Cabs offers the most competitive prices in the area without compromising on service quality, driver professionalism, or vehicle cleanliness."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs provides top-rated cab services across Pune including airport transfers, outstation rides, and city commutes. Book anytime for reliable service and a comfortable travel experience."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers professional Pune to Mumbai Airport cab services. Enjoy door-to-door pickup, on-time arrivals, and a comfortable ride in a vehicle of your choice including Ertiga and Innova."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Whether you need a one-way trip or a round journey, Skyline Cabs offers affordable and quality Pune to Mumbai cab services. Choose from sedans, SUVs, and premium vehicles for your comfort."
    },
    {
      "name": "Cab Service in Charholi Budruk Pune",
      "description": "Skyline Cabs delivers reliable cab service in Charholi Budruk, Pune. Ideal for airport transfers, business travel, or personal trips to Mumbai, our services operate 24/7 with top-rated customer support."
    }
  ],
  "tableData": [
    ["Cab Service in Alandi Pune", "Cab Service in Alandi Pune Contact Number"],
    ["Alandi to Mumbai Cabs Service", "Alandi to Mumbai Airport Cabs"],
    ["Cab Service in Wadmukhwadi", "Cab Service in Charholi Budruk"],
    ["24 Hours Cab Service in Charholi", "Charholi to Mumbai Cab Service"],
    ["Moshi to Mumbai Cab Service", "Moshi to Mumbai Cab Fare"],
    ["Moshi to Mumbai Airport Cab Fare", "Moshi to Mumbai Round Trip Cab Fare"],
    ["Cab Service in Moshi", "Cheapest Cab Service in Moshi"],
    ["Cab Service in Pune", "Pune to Mumbai Airport Cab"],
    ["Pune Mumbai Cab", "Cab Service in Charholi Budruk Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Alandi to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers a dependable and timely cab service from Alandi to Mumbai, ensuring a hassle-free journey for pilgrims, professionals, families, and solo travelers alike. Whether you're traveling for spiritual reasons or personal commitments, we ensure a smooth and punctual experience every time."
    },
    {
        "WhyChooseheading": "Comfortable and Clean Vehicles",
        "WhyChoosedescription": "Travel in complete comfort with our fleet of well-maintained vehicles, including sedans, SUVs, and luxury cars. Every cab is thoroughly cleaned, air-conditioned, and equipped for a relaxing journey from Alandi to Mumbai, no matter the season or traffic conditions."
    },
    {
        "WhyChooseheading": "Skilled and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are well-versed with the Alandi to Mumbai route and offer courteous, safe, and professional service. Trained to handle long-distance travel, they prioritize your comfort and safety, making your trip pleasant and worry-free."
    },
    {
        "WhyChooseheading": "Upfront and Transparent Pricing",
        "WhyChoosedescription": "Enjoy affordable fares with no hidden charges. Skyline Cabs provides upfront pricing so you know exactly what you're paying for before your journey starts. Our transparent billing makes travel planning simple and stress-free."
    },
    {
        "WhyChooseheading": "24/7 Service Availability",
        "WhyChoosedescription": "Whether you need an early morning pickup or a late-night drop-off, Skyline Cabs operates 24/7. You can book your Alandi to Mumbai cab at any time and we’ll be there—on schedule and ready to go."
    },
    {
        "WhyChooseheading": "Vehicles for Every Travel Need",
        "WhyChoosedescription": "Whether you’re traveling solo, with family, or in a group, we have a wide range of vehicles to choose from. From compact sedans to spacious SUVs, we cater to every need, ensuring comfort and convenience throughout your trip."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking your cab from Alandi to Mumbai is quick and convenient with Skyline Cabs. Use our mobile app or website for instant bookings, real-time tracking, and digital payments, making your travel experience seamless from start to finish."
    },
    {
        "WhyChooseheading": "Safe and Secure Journey Guaranteed",
        "WhyChoosedescription": "All our vehicles are GPS-enabled and driven by background-verified drivers. Your safety is our top priority—whether you're traveling during the day or night, you can count on Skyline Cabs for a secure and reliable ride from Alandi to Mumbai."
    }
]



















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Alandi to Mumbai with Skyline Cabs?',
            answer:
                'You can book your ride easily through our website or mobile app. Just choose Alandi as your pickup location and Mumbai as the drop-off point. Select the vehicle type, confirm your booking, and leave the rest to us.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for Alandi to Mumbai travel?',
            answer:
                'Skyline Cabs offers a variety of vehicles such as Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. You can pick the vehicle that suits your travel needs and comfort level.',
        },
        {
            id: 3,
            question: 'Is the fare from Alandi to Mumbai fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing. The fare includes tolls, taxes, and driver charges. There are no hidden fees, and you’ll see the total price upfront before booking.',
        },
        {
            id: 4,
            question: 'Can I book a round-trip cab from Alandi to Mumbai?',
            answer:
                'Of course! We offer both one-way and round-trip bookings. If you know your return date and time, simply include that in your booking, and we’ll manage your round-trip conveniently.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Alandi to Mumbai?',
            answer:
                'The journey from Alandi to Mumbai usually takes around 4 hours, depending on traffic and weather conditions. Our drivers ensure a safe and timely arrival.',
        },
        {
            id: 6,
            question: 'Are the drivers experienced and reliable?',
            answer:
                'Yes, all our drivers are professional, background-verified, and trained for long-distance routes like Alandi to Mumbai. They ensure your journey is smooth and secure.',
        },
        {
            id: 7,
            question: 'Can I use this cab service for airport transfers from Alandi to Mumbai?',
            answer:
                'Yes, we offer direct airport drop services from Alandi to Mumbai’s Domestic and International Airports. Share your flight details and we’ll make sure you arrive with time to spare.',
        },
        {
            id: 8,
            question: 'Are your cabs clean and comfortable?',
            answer:
                'Definitely. All Skyline cabs are regularly cleaned, sanitized, and air-conditioned. We focus on hygiene and comfort to give you a pleasant ride.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my booking if my plans change?',
            answer:
                'Yes, Skyline Cabs offers flexible booking options. You can cancel or modify your ride through the app, website, or by contacting our support team.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs from Alandi to Mumbai?',
            answer:
                'We provide on-time service, professional drivers, multiple vehicle options, and fixed pricing. Whether it’s a business trip, pilgrimage return, or airport transfer, Skyline Cabs ensures a stress-free journey from Alandi to Mumbai.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Prashant Gokhale",
            rating: 5,
            review: "I booked a cab from Alandi to Mumbai after a temple visit. The car arrived on time, was extremely clean, and the driver was very polite and helpful. Great experience with Skyline Cabs!"
        },
        {
            name: "Miss. Meenal Joshi",
            rating: 4,
            review: "Very smooth ride from Alandi to Mumbai. I traveled with my mother and the driver was respectful and made sure we were comfortable throughout. Would love a water bottle service onboard, but otherwise, highly recommended!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Alandi to Mumbai Cabs",
  "image": "https://skylinecabs.com/assets/images/alandi-to-mumbai-cab.jpg",
  "description": "Book Alandi to Mumbai cabs with Skyline Cabs for safe, convenient, and affordable travel. Get 24/7 cab service with AC sedans or SUVs, experienced drivers, and on-time pickups for one-way or round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7156"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/alandi-to-mumbai-cabs"
  }
};


      

      

    return (
        <div>
 <Helmet>
  <title>Alandi to Mumbai Cabs | Safe & On-Time AC Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Alandi to Mumbai cabs with Skyline Cabs for safe, convenient, and affordable travel. Get 24/7 cab service with AC sedans or SUVs, experienced drivers, and on-time pickups for one-way or round trips." 
  />
  <meta 
    name="keywords" 
    content="Alandi to Mumbai Cabs, Cab from Alandi to Mumbai, One-Way Taxi Alandi to Mumbai, Round Trip Cab Alandi to Mumbai, AC Cab Alandi to Mumbai, SUV Taxi Alandi to Mumbai, Affordable Cab Service Alandi to Mumbai, Online Cab Booking Alandi Mumbai, 24/7 Taxi Alandi to Mumbai, Skyline Cabs Alandi to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/27.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Alanditomumbaicabs;